import React, { useState, useEffect, useContext } from "react";

import { Paper } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import { useStyles } from "./style";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import {
  EnhancedTableToolbar,
  CardItem,
} from "../../../components/pages/reports/accountStatement/index";

import { AccountStatementContext } from "../../../context/states/reports/accountStatementState";

const initialState = {
  isSearch: false,
  companyId: "",
  company: "",
  fromDate: null,
  toDate: null,
  businessType: "",
};

const AccountStatement = () => {
  const classes = useStyles();
  const matches = useMediaQuery("(min-width:1920px)");

  const {
    reports,
    getReportsHandler,
    isloading,
    getClientsHandler,
    clients,
    clearStateHandler,
    totalAcAmount,
    totalIpAmount,
    totalPaidJobs,
    totalvat,
    totalService,
    lilAmount,
  } = useContext(AccountStatementContext);

  const [values, setValues] = useState({ ...initialState });
  const [dense] = useState(true);

  // Load Account Statement initially
  useEffect(() => {
    getReportsHandler("");
  }, []);

  const handleChange = (event) => {
    const { name, checked, value, type } = event.target;

    setValues((prev) => ({
      ...prev,
      [name]:
        name === "businessType"
          ? checked
            ? "Private"
            : ""
          : type === "checkbox"
            ? checked
            : value,
    }));
  };

  const handleChangeAutoComplete = (name) => (event, value) => {
    if (value === null) {
      setValues({ ...initialState });
      clearStateHandler();
      return;
    }

    if (name === "company") {
      setValues((prev) => ({
        ...prev,
        company: value,
        companyId: value._id,
      }));
    }
  };

  const handleInputChange = (event) => {
    if (event.target.value === "") return;

    getClientsHandler(event.target.value);
  };

  const handleFromDateChange = (event) => {
    const date = new Date(event).toISOString();

    setValues((prev) => ({
      ...prev,
      fromDate: date,
    }));
  };

  const handleToDateChange = (event) => {
    const date = new Date(event).toISOString();

    setValues((prev) => ({
      ...prev,
      toDate: date,
    }));
  };

  const searchHandler = () => {
    setValues((prev) => ({
      ...prev,
      isSearch: true,
    }));

    let query = "?";

    if (values.companyId !== "") {
      query += `companyId=${values.companyId}`;
    }

    if (values.businessType !== "") {
      query += `${
        query.length > 1 ? "&" : ""
      }businessType=${values.businessType}`;
    }

    if (values.fromDate !== null) {
      query += `${query.length > 1 ? "&" : ""}fromDate=${values.fromDate}`;

      if (values.toDate !== null) {
        query += `&toDate=${values.toDate}`;
      }
    }

    getReportsHandler(query);
  };

  const clearSearchHandler = () => {
    setValues({ ...initialState });

    clearStateHandler();
    getReportsHandler("");
  };

  return (
    <React.Fragment>
      <div className={classes.rootM} style={{ width: "100%" }}>
        <Paper className={classes.paper}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <EnhancedTableToolbar
              handleChange={handleChange}
              values={values}
              isClients={clients}
              handleInputChange={handleInputChange}
              handleChangeAutoComplete={handleChangeAutoComplete}
              totalPaidAmount={totalPaidJobs}
              totalAcAmount={totalAcAmount}
              totalIpAmount={totalIpAmount}
              totalService={totalService}
              totalvat={totalvat}
              lilAmount={lilAmount}
              title="LIL Account Statement"
              handleFromDateChange={handleFromDateChange}
              handleToDateChange={handleToDateChange}
              searchHandler={searchHandler}
              clearSearchHandler={clearSearchHandler}
            />
          </MuiPickersUtilsProvider>

          <CardItem
            title="LIL Account Statement"
            active={classes.paidStage}
            classes={classes}
            isLoading={isloading}
            data={reports}
            hasData={reports && reports.length > 0}
            values={values}
            dense={dense}
            matches={matches}
            account={true}
            refund={false}
          />
        </Paper>
      </div>
    </React.Fragment>
  );
};

export default AccountStatement;
